// Lightweight i18n: en (primary) + fr + es. Every user-visible string is keyed
// and present in all three locales (ADR-LOCALE-001).
import en from "./en";
import fr from "./fr";
import es from "./es";

export type Locale = "en" | "fr" | "es";
const catalogs: Record<Locale, Record<string, string>> = { en, fr, es };

let current: Locale = (localStorage.getItem("aicos.locale") as Locale) || "en";

export function setLocale(l: Locale): void {
  current = l;
  localStorage.setItem("aicos.locale", l);
}

export function getLocale(): Locale {
  return current;
}

export function t(key: string, vars?: Record<string, string | number>): string {
  let s = catalogs[current][key] ?? catalogs.en[key] ?? key;
  if (vars) for (const [k, v] of Object.entries(vars)) s = s.replace(new RegExp(`\\{${k}\\}`, "g"), String(v));
  return s;
}
